namespace TabAurous.ECommerce {
    export var total = 0;

    @Serenity.Decorators.registerClass() 
    export class ECommSalesForOrderDialog extends _Ext.TransDialog<ECommSalesRow, any> {

        protected getFormKey() { return ECommSalesForm.formKey; }
        protected getIdProperty() { return ECommSalesRow.idProperty; }
        protected getLocalTextPrefix() { return ECommSalesRow.localTextPrefix; }
        protected getNameProperty() { return ECommSalesRow.nameProperty; }
        protected getService() { return ECommSalesService.baseUrl; }
        protected getDeletePermission() { return ECommSalesRow.deletePermission; }
        protected getInsertPermission() { return ECommSalesRow.insertPermission; }
        protected getUpdatePermission() { return ECommSalesRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }
        protected useViewMode() { return true; }

        public form = new ECommSalesForm(this.idPrefix);
        public PartyId: number;
        public RateListId: number = 0;
        public LaborListId: number = 0;
        public StoneMarkup: number = 0;
        public StoneDiscount: number = 0;
        public LaborMarkup: number = 0;
        public LaborDiscount: number = 0;
        public ExchangeRate: number = 0;

        TaxArray: any[]; 
        //total: number;
        public total1: number; 
        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            q.initItemEditor(this, this.form.ReceiptDetails, Config);
            this.element.find('.panel-titlebar-close').remove();

            this.element.siblings("panel-titlebar").find("button.panel-titlebar-close").remove()

            //$('.panel-titlebar-close').attr("style", "display:none;");
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.GiftDetails);
            q.hideEditorLabel(this.form.TaxDetails);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.hideEditorLabel(this.form.PromoDetails);
            q.hideEditorToolbar(this.form.PromoDetails);

            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.BalanceAmount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.Receipt);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Discount);
            //q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 250);
            q.setGridEditorHeight(this.form.GiftDetails, 250);
            q.hideEditorToolbar(this.form.TaxDetails);//To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ImageName);
            q.SetCategoryFourColumn(this.form.BillingAddress);
            q.SetCategoryTwoColumn(this.form.VoucherTypeId);
            q.SetCategoryFourColumn(this.form.ShippingAddress);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.GiftDetails);
            q.SetSix12Column(this.form.ReceiptDetails);
            q.SetSix12Column(this.form.TaxDetails);

            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategorySixColumn(this.form.Remark);


            q.hideEditorCategoryLabel(this.form.TransDate.element);
            q.hideEditorCategoryLabel(this.form.ImageName.element);
            q.hideEditorCategoryLabel(this.form.VoucherTypeId.element);
            q.hideEditorCategoryLabel(this.form.BillNo.element);
            q.hideEditorCategoryLabel(this.form.ItemDetails.element);
            q.hideEditorCategoryLabel(this.form.ReceiptDetails.element);
            q.hideEditorCategoryLabel(this.form.Pieces.element);
            q.hideEditorCategoryLabel(this.form.NetAmount.element);
            q.hideEditorCategoryLabel(this.form.Remark.element);


            q.setTextRightAlign(this.form.RoundOff);
            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });

            q.hideCaption(this.form.CustomerName);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ReceiptDetails, Config);

            this.form.POSCustomerId.changeSelect2(e => {
                var cid = parseInt(this.form.POSCustomerId.value);
                this.form.ReceiptDetails.POSCustomerId = parseInt(this.form.POSCustomerId.value);

                if (cid > 0) {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    this.form.POSCustomerId.value = CustomerDetails.POSCustomerId.toString();
                    this.form.BirthDate.value = CustomerDetails.BirthDate;
                    this.form.Anniversary.value = CustomerDetails.Anniversary;
                    this.form.Mobile.value = (CustomerDetails.Mobile);
                    this.form.TaxId.value = CustomerDetails.TaxId;
                }
            });

            this.form.EmployeeId.changeSelect2(e => {
                this.form.ItemDetails.salespersonId = parseInt(this.form.EmployeeId.value);

            })

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            var total = 0;

            (this.form.ReceiptDetails.view as any).onRowCountChanged.subscribe(() => {

                this.CalculateBalanceAmt();
            });
            var giftItems = [];
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);

                this.forOrderAdvance(Items);
            })



            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
                //alert(total);

            });


            var fieldEditor: JQuery = this.form.POSCustomerId.element.closest(".editor");

            fieldEditor.addClass("has-inplace-button");
            $('<a><b/>...</a>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

            this.form.GrossAmount.change(e => {
                this.form.NetAmount.value = this.form.GrossAmount.value;
            });


            this.validateForm();

        }
        forOrderAdvance(Items: ECommSalesItemsRow[]) {
            if (!this.isViewMode()) {
                var transids = [];
                for (var i = 0; i < Items.length; i++) {
                    if (Items[i].RefVoucherId == 47) {
                        transids.push(Items[i].RefTransId);
                    }
                }
                let advances = [];
                if (this.form.ItemDetails.getItems().length > 0) {
                    ReceiptService.GetAdvanceList({ TransIds: transids }, response => advances = response.Entities,
                        {
                            async: false
                        });

                    if (advances != null && advances.length > 0)
                        this.form.ReceiptDetails.setAdvance(advances);
                }
            }

        }

        // **** Total Weight, Amount and TAX Calculation ****
        CalculateAmountandTax(Items: ECommSalesItemsRow[], TotalItems: number) {
            if (!this.isViewMode()) {

                var HSN = [];
                var Amount = [];
                var TaxDetail = [];
                var ItemTotal = 0;
                var GiftVouchers = this.form.GiftDetails.getItems();
                var ProductType = [];
                var ProductAmount = [];
                var ProductLabour = [];
                var Promos = [];

                var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0; var giftAmount = 0;

                for (var x of Items) {
                    ntamt += x.NetAmount || 0;
                    gramt += x.GrossAmount || 0;
                    disc += x.Discount || 0;
                    pcs += x.Pieces || 0;
                    wt += x.Weight || 0;
                    nwt += x.NetWeight || 0;

                    var temp = false;
                    for (let i = 0; i < HSN.length; i++) {
                        if (HSN[i] == x.TaxCode) {
                            Amount[i] += x.GrossAmount || 0;
                            temp = true;
                        }
                    }

                    if (!temp) {
                        HSN.push(x.TaxCode);
                        Amount.push(x.GrossAmount);
                    }

                    // **** To calculate Values for Promotion ****
                    if (x.ProductTypeId != null) {
                        var temp = false;
                        for (let i = 0; i < ProductType.length; i++) {
                            if (ProductType[i] == x.ProductTypeId) {
                                ProductAmount[i] += x.GrossAmount || 0;
                                ProductLabour[i] += x.UnitLabour || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            ProductType.push(x.ProductTypeId);
                            ProductAmount.push(x.GrossAmount);
                            ProductLabour.push(x.UnitLabour);
                        }
                    }

                    ItemTotal++;
                };


                //**** Get and Apply Promotion
                if (ItemTotal == TotalItems) {
                    var Discount: number;
                    for (let i = 0; i < ProductType.length; i++) {

                        var baseitemid = ProductType[i];
                        var date = q.formatDate(this.form.TransDate.value, "dd/MM/yyyy");
                        var Promo;
                        //= OMS.PromotionDetailsRow.getLookup().items.filter(x => x.ProductTypeId == baseitemid
                        //    && x.CompanyId == Q.Authorization.userDefinition.CompanyId
                        //    && x.IsDisabled == true && x.IsApproved == true
                        //    && new Date(x.FromDate) <= this.form.TransDate.valueAsDate
                        //    && new Date(x.ToDate) >= this.form.TransDate.valueAsDate
                        //)[0];
                        OMS.PromotionDetailsService.GetPromotions({
                            ProductTypeId: baseitemid,
                            CompanyId: Q.Authorization.userDefinition.CompanyId,
                            IsDisabled: true, IsApproved: true,
                            FromDate: this.form.TransDate.value,
                            ToDate: this.form.TransDate.value
                        }, response => {
                            if (response.Entities != null && response.Entities.length > 0)
                                Promo = response.Entities[0];
                        });

                        if (Promo != undefined) {
                            if (Promo.ApplicableOn == 163) {
                                if (Promo.DiscountOn == "2") {
                                    Discount = (ProductLabour[i] * Promo.DiscountPercentage) / 100
                                }
                                else {
                                    Discount = Promo.DiscountAmount;
                                }
                            }
                            else {
                                if (Promo.DiscountOn == "2") {
                                    Discount = (ProductAmount[i] * Promo.DiscountPercentage) / 100
                                }
                                else {
                                    Discount = Promo.DiscountAmount;
                                }

                            }

                            var PromoAmount = Promo.ApplicableOn == 163 ? ProductLabour[i] : ProductAmount[i];
                            //this.form.Discount.value += Discount;
                            var NewPromo: ECommSalesPromoRow = {
                                PromoId: Promo.PromoId,
                                PromoPer: Promo.DiscountPercentage,
                                ProductTypeId: ProductType[i],
                                TotalAmount: PromoAmount,
                                PromoAmount: Discount,
                                PromoCode: Promo.PromoCode,
                                ProductTypeName: Promo.ProductTypeName
                            }

                            Promos.push(NewPromo);
                        }
                    }
                }

                var temp2 = this.form.PromoDetails.getData(Promos);
                this.form.PromoDetails.view.setItems(temp2, true);
                var PromoDiscount = 0;
                for (let i = 0; i < Promos.length; i++) {
                    PromoDiscount += Promos[i].PromoAmount;
                }
                this.form.NetAmount.value = gramt;
                this.form.Discount.value = disc + PromoDiscount;

                var TaxAmount = 0;

                var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

                if (ItemTotal == TotalItems && TaxApplicable) {

                    var TaxItems = this.form.TaxDetails.getItems().length;
                    var it = this.form.TaxDetails.getItems();
                    if (TaxItems > 0) {
                        this.form.TaxDetails.DeleteTax();
                    }

                    //TODO: Get Company Country to Call appropriate TAX Helper

                    TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, 1);

                    //Get Taxes for Voucher
                    TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);

                    var temp2 = this.form.TaxDetails.getData(TaxDetail);
                    this.form.TaxDetails.view.setItems(temp2, true);

                    TaxDetail.forEach(function (value) {
                        if (value.TaxType != "TDS")
                            TaxAmount += value.TaxAmount;
                        else
                            tds += value.TaxAmount;

                    });

                    this.form.TaxAmount.value = TaxAmount;
                    this.form.GrossAmount.value = gramt + TaxAmount - disc - PromoDiscount;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                else {
                    this.form.GrossAmount.value = gramt - disc - PromoDiscount;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }

                for (var i = 0; i < GiftVouchers.length; i++) {
                    giftAmount += GiftVouchers[i].Value;
                }
                this.form.GrossAmount.value += giftAmount;


                if (this.form.GrossAmount.value > 0) {
                    if (this.form.Receipt.value == undefined)
                        this.form.Receipt.value = 0;

                    this.form.BalanceAmount.value = this.form.GrossAmount.value - this.form.Receipt.value;
                }
            }
        }

        CalculateBalanceAmt() {
            if (!this.isViewMode()) {
                total = 0;
                var receipts = this.form.ReceiptDetails.getItems();
                for (var i = 0; i < receipts.length; i++) {
                    total += receipts[i].Amount;
                }

                this.form.Receipt.value = total;
                this.form.BalanceAmount.value = this.form.GrossAmount.value - total;
            }
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            var address = this.entity.AddressDetails;
            if (address != undefined && address != null) {
                for (var i = 0; i < address.length; i++) {
                    if (address[i].Type == 47) {
                        this.form.ShippingState.cascadeField = "CountryId";
                        this.form.ShippingState.cascadeValue = address[i].Country.toString();
                        this.form.ShippingCity.cascadeField = "StateId";
                        this.form.ShippingCity.cascadeValue = address[i].State.toString();

                        this.form.ShippingAddress.value = address[i].Address1.toString();
                        this.form.ShippingCity.value = address[i].City.toString();
                        this.form.ShippingCityName.value = address[i].City.toString();
                        this.form.ShippingState.value = address[i].State != null ? address[i].State.toString() : "0";
                        this.form.ShippingStateName.value = address[i].StateName;
                        this.form.ShippingCountry.value = address[i].Country.toString();
                        this.form.ShippingCountryName.value = address[i].CountryName;
                        this.form.ShippingPincode.value = address[i].Pincode;
                        this.form.ShippingPhone.value = address[i].Phone;
                    } else if (address[i].Type == 48) {
                        this.form.BillingAddress.value = address[i].Address1;
                        this.form.BillingCity.value = address[i].City;
                        this.form.BillingCityName.value = address[i].City.toString();
                        this.form.BillingState.value = address[i].State != null ? address[i].State : 0;
                        this.form.BillingStateName.value = address[i].StateName;
                        this.form.BillingCountry.value = address[i].Country;
                        this.form.BillingCountryName.value = address[i].CountryName;
                        this.form.BillingPin.value = address[i].Pincode;
                        this.form.BillingPhone.value = address[i].Phone;
                    }
                }
            }
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.PosCustomerMasterGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.PosCustomerMasterRow[]) => {

                this.form.POSCustomerId.value = selectedItems[0].POSCustomerId.toString(); 
                this.form.BirthDate.value = selectedItems[0].BirthDate;
                this.form.Anniversary.value = selectedItems[0].Anniversary;
                this.form.Mobile.value =  (selectedItems[0].Mobile); 
                this.form.TaxId.value = selectedItems[0].TaxId;
            }
            pickerDialog.dialogOpen();

        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            //this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());

            var CompanyDetails = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId];
            if (CompanyDetails.IsPriceList) {
                this.RateListId = CompanyDetails.SPriceListId || 0;
                this.StoneMarkup = CompanyDetails.SMarkup || 0;
            }

            if (CompanyDetails.IsLabourList) {
                this.LaborListId = CompanyDetails.SLabourListId || 0;
                this.LaborMarkup = CompanyDetails.SLMarkup || 0;
            }

           
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
            //var reportoptions: _Ext.ReportExecuteOptions = {

            //}
            //Export PDF Button
            btns.push(_Ext.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                reportKey: 'ECommerce.ECommSalesVoucher',

                getParams: () => ({
                    TransID: this.get_entityId()
                }),
            }));
            btns.push({
                title: 'Export',
                cssClass: 'send-button',
                onClick: () => {

                    ECommSalesService.ECommInvoiceExportExcel({
                        Invoice: this.entity,
                    }, response => {

                    }, { async: false });
                }
            });
            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else if (this.form.GiftDetails.getItems().length > 0) {
                var gifts = this.form.GiftDetails.getItems();
                for (var i = 0; i < gifts.length; i++) {
                    var giftdetail = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == gifts[i].UniqueCode && x.IsRedeemed == true)[0];
                    if (giftdetail != undefined) {
                        if (giftdetail.IsRedeemed == true) {
                            Q.alert("Gift Voucher with Code'" + gifts[i].UniqueCode + "' has been Redeemed.Cannot Delete!");
                            return;
                        }
                    }
                }
            }
            else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                ECommSalesService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
         

        //protected validateBeforeSave() {
        //    for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
        //        let items = this.form.ItemDetails.getItems();
        //        items[i].BOMDetails.forEach(function (x) {
        //            if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
        //                var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' + items[i].ProductCode + '", Cannot Save!');
        //                Q.alert(msg)
        //                return false;
        //            }
        //        })
        //    }
        //    return false
        //}
        //
        protected validateBeforeSave() { 
            var Isvalid =false;
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' + items[i].ProductCode + '", Cannot Save!');
                        Q.alert(msg)
                        Isvalid = false;
                        return false;
                    }
                })

                if (items[i].LaborDetails != undefined && items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                            return false;
                        }
                    })
                }
            }
             
            total = this.form.Receipt.value;
            if ((total + this.form.BalanceAmount.value) !== parseFloat(this.form.GrossAmount.value.toString())) {


                Q.confirm('Payments and Gross Amount do not match.. Do you want to add the balance as Credit', () => {
                    var dialog = new AuthorizeDialog();
                    dialog.inst = this;
                    dialog.entityId = this.entity.TransId;
                    dialog.voucherno = this.form.VoucherNo.value;
                    dialog.vouchertypeid = this.form.VoucherTypeId.value;


                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            this.form.BalanceAmount.value = this.form.GrossAmount.value - total;
                            this.save();
                            this.dialogClose();
                            Isvalid = true;

                        }
                    });
                    dialog.dialogOpen();
                }, {});
            } else if ((total + this.form.BalanceAmount.value) == parseFloat(this.form.GrossAmount.value.toString())) {
                Isvalid = true;
                return true;
            }
            else {
                Isvalid = false;
                return false;
            }
            return Isvalid;

        }
    }
}